import { Component } from '@angular/core';
import { CompanySettingsComponent } from '../../../settings/account-settings-drawer/company-settings/company-settings.component';

@Component({
  selector: 'tenant-company-settings-section',
  standalone: true,
  imports: [CompanySettingsComponent],
  template: `
    <div class="settings-section">
      <div class="settings-section-header">
        <h2 class="settings-section-title">Company Settings</h2>
        <p class="settings-section-description">
          Manage your company information, logo, and contact details
        </p>
      </div>
      <div class="settings-section-content">
        <tenant-company-settings></tenant-company-settings>
      </div>
    </div>
  `,
  styles: [
    `
    .settings-section {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }

    .settings-section-header {
      border-bottom: 1px solid var(--sidebar-border);
      padding-bottom: 16px;
    }

    .settings-section-title {
      font-size: 20px;
      font-weight: 600;
      color: var(--header-text);
      margin: 0 0 4px 0;
    }

    .settings-section-description {
      font-size: 14px;
      color: var(--header-text-secondary);
      margin: 0;
    }

    .settings-section-content {
      /* Content styles handled by child component */
    }
  `,
  ],
})
export class CompanySettingsSectionComponent {}
